import { keyframes } from 'styled-components'

export const blinkKeyframesBorder = keyframes`
  0% {
    border: 1.5px solid var(--tds-information);
  }
  50% {
    border: 1.5px solid var(--tds-grey-300);
  }
  100% {
    border: 1.5px solid var(--tds-information);
  }
`
